export const GENERIC_ERROR_MESSAGE = "Something went wrong";
export const HELP_URL = "https://businesscenter.att.com/ebiz/ebcsupport/v2/index.html#/ebcsupport/topic?module_id=topic_userguides/topic_attbusinessvoice2";
export const HALOB_PROVIDER = "attcustomeroidc";
export const HALOE_PROVIDER = "attoidc";
export const ANONYMOUS_NUMBER = "Anonymous";
export const STARTING_DELAY = 500;
export const TIME_MULTIPLE = 4;
export const MAX_DELAY = 8000;
export const NUM_OF_ATTEMPTS = 5;
